import {UI} from "../../../../stem-core/src/ui/UIBase";
import {Messages} from "../../../Messages";
import {Link} from "../../../../stem-core/src/ui/UIPrimitives";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {ThankYouPanelStyle} from "../thank-you/ThankYouPanel";
import {MerchantButton} from "../../../common/MerchantButton";
import {DonationStore} from "../../../../client/state/DonationStore";
import {DONATE_PAGE_URLS} from "../../PanelConstants";
import {PoweredByBlink} from "../../PoweredByBlink";
import {styleRuleInherit} from "../../../../stem-core/src/decorators/Style";
import {redirectToMerchantHomepage} from "../../../widget/misc/WidgetUtils";
import {iFrameMerchantService} from "../../../services/IframeMerchantService";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService";
import {MessageElement} from "../../../widget/ui/MessageElement";


class DonationUpdatedPanelStyle extends ThankYouPanelStyle {
    @styleRuleInherit
    button = {
        marginBottom: 8,
        marginTop: 0,
    }
}

@registerStyle(DonationUpdatedPanelStyle)
export class DonationUpdatedPanel extends UI.Element {
    render() {
        const {styleSheet} = this;
        const donation = iFrameUserDataService.getActiveRecurringDonation();
        const publicationName = iFrameMerchantService.getMerchant().name;

        return [
            <div className={styleSheet.title}>{Messages.donatePageDonationUpdatedTitle}</div>,
            <MessageElement message={Messages.donatePageDonationUpdatedText1(donation.formatPrice())}
                            className={styleSheet.text}/>,
            <div className={styleSheet.text}>{Messages.donatePageDonationUpdatedText2}</div>,
            <div className={styleSheet.text}>
                {Messages.donatePageDonationUpdatedText3}
                <Link className={styleSheet.dashboardLink} newTab href="/" value={Messages.dashboard}/>.
            </div>,
            <MerchantButton className={styleSheet.button} onClick={redirectToMerchantHomepage}>
                {Messages.returnToHomepage(publicationName)}
            </MerchantButton>,
            <PoweredByBlink />,
        ];
    }

    onMount() {
        super.onMount();
        this.attachChangeListener(DonationStore, () => {
            if (!iFrameUserDataService.getActiveRecurringDonation()) {
                this.options.changeURL(DONATE_PAGE_URLS.donate, true);
            } else {
                this.redraw();
            }
        });
    }
}
